import React, { memo, useContext } from 'react';
import classNames from 'classnames';
import Button from '../button';
import Icon from '../icon';
import Dropdown from './dropdown';
import ConfigContext from '../config-provider/ConfigContext';
const ButtonGroup = Button.Group;
const DropdownButton = function DropdownButton(props) {
    const { prefixCls: customizePrefixCls, type, disabled, onClick, children, className, overlay, trigger, align, visible, onVisibleChange, placement, getPopupContainer, ...restProps } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
    const dropdownProps = {
        align,
        overlay,
        disabled,
        trigger: disabled ? [] : trigger,
        onVisibleChange,
        placement,
        getPopupContainer,
    };
    if ('visible' in props) {
        dropdownProps.visible = visible;
    }
    return (React.createElement(ButtonGroup, Object.assign({}, restProps, { className: classNames(prefixCls, className) }),
        React.createElement(Button, { type: type, disabled: disabled, onClick: onClick }, children),
        React.createElement(Dropdown, Object.assign({}, dropdownProps),
            React.createElement(Button, { type: type },
                React.createElement(Icon, { type: "arrow_drop_down" })))));
};
DropdownButton.displayName = 'DropdownButton';
DropdownButton.defaultProps = {
    placement: 'bottomRight',
};
export default memo(DropdownButton);
